import { minutesToSeconds } from 'date-fns';

import { MixedItem } from 'store/railsBuilder/reducer.types';

import { BtvProgramme } from 'services/data-manager/types';

import getRBAssetChannelId from './getRBAssetChannelId';
import getRBBtvProgrammeDetailsParams from './getRBBtvProgrammeDetailsParams';
import getTechnicalTime from './utils/getTechnicalTime';
import parseParentalRating from './utils/parseParentalRating';

function parseRBBtvProgrammeToMixedItem(btvProgramme: BtvProgramme): MixedItem {
    const {
        id,
        type,
        contentType,
        playbackType,
        title,
        period,
        Title,
        editorial,
        CUEndDate,
        isCatchUp,
        isStartOver,
        links,
        Countries,
        Genre,
    } = btvProgramme;

    return {
        id: id || 'unknown',
        type,
        contentType,
        playbackType,
        position: editorial?.position,
        duration: period?.duration,
        title: title || Title || '',
        channelId: getRBAssetChannelId(btvProgramme),
        seriesId: editorial?.seriesRef,
        season: editorial?.SeasonNumber,
        episode: editorial?.episodeNumber,
        episodeTitle: editorial?.Episode,
        startTime: getTechnicalTime(
            editorial?.technicals?.[0]?.ProgrammeStartDate ??
                editorial?.period?.start,
        ),
        endTime: getTechnicalTime(
            editorial?.technicals?.[0]?.ProgrammeEndDate ??
                editorial?.period?.end,
        ),
        year: editorial?.Year,
        parentalRating: parseParentalRating(btvProgramme),
        countries: Countries,
        genres: Genre,
        CUEndDate,
        isCatchUp,
        isStartOver,
        links,
        detailsPageParams: getRBBtvProgrammeDetailsParams(btvProgramme),
    };
}

export default parseRBBtvProgrammeToMixedItem;
